module.exports = __webpack_public_path__ + "img/4active.f1df96bb.png";